<template>
  <div>
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ $t('importDonne.title') }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
      </div>
    </div>
    <qd-message :title="$t('importDonne.info.title')" class="mgt-20px"
               type="is-info">
      <span v-html="$t('importDonne.info.message')"></span>
    </qd-message>
    <div class="columns is-multiline mgt-20px">
      <qd-collapse class="column is-12 card is-paddingless mgb-20px" animation="slide"
        v-for="(typeImport, index) in typesImports" :key="index">
        <template #trigger="props">
          <div class="card-header" role="button" aria-controls="contentIdForA11y3">
            <p class="card-header-title">
              {{ $t(typeImport.title) }}
            </p>
            <a class="card-header-icon">
              <b-icon
                :icon="props.open ? 'menu-down' : 'menu-up'">
              </b-icon>
            </a>
          </div>
        </template>
        <div class="card-content">
          <error-msg-component :messages="typeImport.messages"
                                :messagesChampsVide="typeImport.messagesChampsVide"
                                :champsVide="typeImport.champsVide"
                                :error="typeImport.isError"
                                title="general.problemOccurred"
                                :withEmplyFields="false"
                                @close="typeImport.isError = false"/>
          <qd-message v-if="typeImport.dataIsReady && type === typeImport.type"
            :title="$t('importDonne.infoDataPret.title')"
            type="is-success"
            has-icon
            aria-close-label="Close message">
            <span>{{$t('importDonne.infoDataPret.message')}}</span>
          </qd-message>
          <div class="content">
            <span v-html="$t(typeImport.description)"></span>
          </div>
        </div>
        <footer class="card-footer">
          <a class="card-footer-item" download
              :href="typeImport.templateFile">
            {{ $t('importDonne.actions.template') }}
          </a>
          <a class="card-footer-item" @click="openPopUpImport(typeImport.type)">
            {{ $t('importDonne.actions.importer') }}
          </a>
          <a class="card-footer-item" v-if="typeImport.type !== typePatrimoine"
            @click="openPopUpPreventionAfterOrNotImport(typeImport.type, true)">
            {{ $t('importDonne.actions.testerDonnees') }}
          </a>
          <a class="card-footer-item"
            @click="openPopUpPreventionAfterOrNotImport(typeImport.type, false)">
            {{ $t('importDonne.actions.envoyer') }}
          </a>
        </footer>
      </qd-collapse>
      <import-card
        v-for="dataType in importDataTypes"
        :key="dataType.type"
        v-bind="dataType">
      </import-card>
    </div>
    <b-modal v-model="popUpImportDonne" has-modal-card class="modal">
      <import-donne @lignesXlsx="importLigne" :all-sheet="allSheet"></import-donne>
    </b-modal>
    <b-modal v-model="popUpPrevention" has-modal-card class="modal">
      <prevention
        :messHeader="$t('importDonne.prevention')"
        :cancel="$t('general.button.cancel')"
        :validate="$t('general.button.next')"
        @no="popUpPrevention = false"
        @yes="importData()">
      </prevention>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import {
  makePatrimoineGenerated, makePatrimoineImport,
} from '@/services/import/patrimoine/makePatrimoineImport';
import { makeCommandeGenerated, makeCommandeImport } from '@/services/import/facture/makeCommandeImport';
import { makeBailleurGenerated, makeBailleurImport } from '@/services/import/bailleur/makeBailleurImport';
import { makeBailGenerated, makeBailImport } from '@/services/import/bail/makeBailImport';
import breadcrumb from '@/components/general/breadcrumb';
import importDonne from '@/components/import/p_importDonne';
import * as Config from '@/configuration/import/importConf';
import prevention from '@/components/general/popUpPrevention';
import messageErreur from '@/services/general/messageErreur';
import messageSuccess from '@/services/general/messageSucces';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import validationBail from '@/services/baux/contrat/validation';
import validationGeneral from '@/services/validation/validation';
import translateBail from '@/services/baux/contrat/translatorContrat';
import validationBailleur from '@/services/baux/bailleur/validationBailleur';
import validationEcheance from '@/services/baux/contrat/validationEcheance';
import champsTiersTranslator from '@/services/tiers/champsTiersTranslator';
import translatePatrimoine from '@/services/gabed/emplacement/validation/champsEmplacementTranslator';
import validationPatrimoine from '@/services/gabed/patrimoine/validationPatrimoine';
import importCard from '@/components/configInterne/importData/importCard';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { TYPE_BON_STOCK } from '@/configuration/import/importConf';

const Parametres = createNamespacedHelpers('parametres');

export default {
  name: 'importData',
  data() {
    return {
      popUpImportDonne: false,
      popUpPrevention: false,
      type: '',
      typePatrimoine: Config.TYPE_PATRIMOINE,
      resultImport: null,
      typesImports: Config.TYPE_IMPORT_DATA,
      typeBailleur: Config.TYPE_BAILLEUR,
      typeBail: Config.TYPE_BAIL,
      typeCommande: Config.TYPE_COMMANDE,
      typeDemandeImpression: Config.TYPE_DEMANDE_IMPRESSION,
      allSheet: false,
      modeTest: false,
      Config,
      TYPE_BON_STOCK,
    };
  },
  components: {
    breadcrumb,
    importDonne,
    prevention,
    errorMsgComponent,
    importCard,
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    openPopUpPreventionAfterOrNotImport(type, isTest) {
      if (this.type === type) {
        this.modeTest = isTest;
        if (isTest) this.importData();
        else this.popUpPrevention = true;
      }
    },
    async importLigne(lignes) {
      this.popUpImportDonne = false;
      const loadingComponent = this.$buefy.loading.open();
      const typeImport = this.typesImports.find(el => el.type === this.type);
      try {
        switch (this.type) {
          case this.typePatrimoine:
            this.resultImport = await makePatrimoineGenerated(lignes);
            typeImport.dataIsReady = this.resultImport && this.resultImport.length > 0;
            break;
          case this.typeBailleur:
            this.resultImport = await makeBailleurGenerated(lignes);
            typeImport.dataIsReady = this.resultImport && this.resultImport.length > 0;
            break;
          case this.typeCommande:
            this.resultImport = await makeCommandeGenerated(lignes[1], lignes[2]);
            typeImport.dataIsReady = this.resultImport && this.resultImport.length > 0;
            break;
          case this.typeBail:
            this.resultImport = await makeBailGenerated(lignes);
            typeImport.dataIsReady = this.resultImport && this.resultImport.length > 0;
            break;
          default:
            break;
        }
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        if (e && Array.isArray(e)) {
          this.resetMessageError();
          if ([this.typeBail, this.typePatrimoine].includes(typeImport.type)) {
            e.forEach(el => {
              if (el.data && el.data.error) {
                validationEcheance(el, typeImport.messages);
                validationGeneral(this.$i18n, el, typeImport.champsVide,
                  typeImport.messages, typeImport.messagesChampsVide);
              } else typeImport.messages = e;
            });
          }
          typeImport.isError = true;
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async importData() {
      this.popUpPrevention = false;
      const loadingComponent = this.$buefy.loading.open();
      const typeImport = this.typesImports.find(el => el.type === this.type);
      try {
        switch (this.type) {
          case this.typePatrimoine:
            typeImport.dataIsReady = false;
            await makePatrimoineImport(this.resultImport);
            break;
          case this.typeBailleur:
            typeImport.dataIsReady = this.modeTest;
            await makeBailleurImport(this.resultImport, this.modeTest);
            break;
          case this.typeBail:
            typeImport.dataIsReady = this.modeTest;
            await makeBailImport(this.resultImport, this.modeTest);
            break;
          case this.typeCommande:
            typeImport.dataIsReady = this.modeTest;
            await makeCommandeImport(this.resultImport, this.modeTest);
            break;
          default:
            break;
        }
        loadingComponent.close();
        messageSuccess(this.modeTest ? this.$t('importDonne.sucessTestImport') : this.$t('importDonne.success'));
      } catch (e) {
        loadingComponent.close();
        if (e.response.data.error) {
          this.loadError(e.response);
          return;
        }
        messageErreur(this.$i18n);
        throw e;
      }
    },
    openPopUpImport(type) {
      this.resultImport = null;
      this.type = type;
      if ([this.typeBail, this.typeCommande].includes(this.type)) this.allSheet = true;
      this.resetMessageError();
      this.popUpImportDonne = true;
    },
    loadError(response) {
      this.resetMessageError();
      const typeImport = this.typesImports.find(el => el.type === this.type);
      let translate = null;
      switch (this.type) {
        case this.typePatrimoine:
          validationPatrimoine(response, typeImport.messages);
          translate = translatePatrimoine;
          break;
        case this.typeBailleur:
          validationBailleur(response, typeImport.messages);
          translate = champsTiersTranslator;
          break;
        case this.typeBail:
          validationBail(response, typeImport.messages, []);
          translate = translateBail;
          break;
        default:
          break;
      }
      validationGeneral(this.$i18n, response, typeImport.champsVide,
        typeImport.messages, typeImport.messagesChampsVide, translate);
      typeImport.isError = true;
    },
    resetMessageError() {
      return this.typesImports.forEach(el => {
        el.messages = [];
        el.messagesChampsVide = [];
        el.champsVide = [];
        el.isError = false;
        el.dataIsReady = false;
      });
    },
  },
  computed: {
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    breadcrumb() {
      return [
        { title: this.$i18n.t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('importDonne.breadcrumb.config'), route: '', isActive: true },
      ];
    },
    moduleStockActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleStockTiers.key);
    },
    importDataTypes() {
      let importTypesArr = Config.IMPORT_DATA_TYPE;
      if (!this.moduleStockActive) {
        importTypesArr = importTypesArr
          .filter(importType => importType.type !== this.TYPE_BON_STOCK);
      }
      return importTypesArr;
    },
  },
  async mounted() {
    this.resetMessageError();
    this.setInformationPage(this.$t('pageConfigInterne.importDonnee'));
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.moduleStockTiers.key,
      ]);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
};
</script>
